export default __webpack_public_path__ + "a35deb3bc77fac07149974486258b0e1.png";